/**
 * Tabs
 */
(function ($){
	$('[role="tablist"]').each(function(){
		const $tabsContainer = $(this),
			$tabsContentContainer = $(this).next(),

			$tabs = $tabsContainer.find('[role="tab"]'),
			$tabsContents = $tabsContentContainer.find('[role="tabpanel"]'),

			effectSpeed = 400

		$tabs.on('click', function(){
			const $tab = $(this),
				$tabSiblings = $tab.siblings(),
				$tabsContent = $tabsContents.filter('#'+ $tab.attr('aria-controls')),
				$tabsContentSiblings = $tabsContent.siblings()

			$tab
				.addClass('btn-primary')
				.removeClass('btn-outline-primary')
				.attr('aria-selected', 'true')

			$tabSiblings
				.addClass('btn-outline-primary')
				.removeClass('btn-primary')
				.attr('aria-selected', 'false')

			$tabsContent.addClass('active')
			$tabsContentSiblings.removeClass('active')
		})

		$tabsContents.each(function(){
			const $tabQuestionContainers = $(this).find('[data-toggle="question"]')

			$tabQuestionContainers.each(function(){
				const $tabQuestionContainer = $(this),
					$tabQuestionContainerSiblings = $tabQuestionContainer.siblings(),
					$tabQuestionTitle = $tabQuestionContainer.find('dt'),
					$tabAnswer = $tabQuestionContainer.find('dd')

				$tabQuestionTitle.on('click', function(){
					$tabAnswer.slideToggle(effectSpeed)

					const $parent = $(this).parent(),
						$parentSiblings = $parent.siblings()

					$parent.toggleClass('active')
					$parentSiblings.removeClass('active')

					$tabQuestionContainerSiblings.find('dd').slideUp(effectSpeed)
				})
			})
		})
	})
})(jQuery)
